export const DOCKET_PREFIXES = [
	"AB",
	"AM",
	"ARB",
	"ASC",
	"CNO",
	"CU",
	"DOP",
	"DSO",
	"EP",
	"EPM",
	"FD",
	"FSA",
	"IS",
	"ISM",
	"MC",
	"MCC",
	"MCF",
	"MXC",
	"NOM",
	"NOR",
	"PTO",
	"RER",
	"RR",
	"S5A",
	"S5M",
	"S5R",
	"SAI",
	"SDM",
	"SO",
	"STA",
	"SUB",
	"SUS",
	"WB",
	"WC",
	"WCC"
];

export const DOCKET_SUFFIXES = [
	"",
	"A",
	"B",
	"C",
	"D",
	"E",
	"F",
	"G",
	"H",
	"I",
	"J",
	"K",
	"L",
	"M",
	"N",
	"P",
	"S",
	"TA",
	"U",
	"X"
];

export const GENERAL_FILING_TYPES = [
	"Amended Application",
	"Amended Complaint",
	"Answer",
	"Appeal",
	"Appeal Arbitration Decision",
	"Application",
	"Arbitration Answer",
	"Arbitration Complaint",
	"Arbitration Joint Notice",
	"Argument",
	"Brief",
	"Certificate Of Compliance With 49 CFR 1150.32(e) or 1150.42(e)",
	"Certificate Of Compliance With Condition",
	"Certificate Of Publication",
	"Certificate Of Service",
	"Comments",
	"Complaint",
	//"Confidential Material Filed Under Seal",
	"Consummation Notice",
	"Discovery",
	"Environmental Comment",
	"Environmental Materials",
	"Errata/Correction",
	"Evidence",
	"Ex Parte Meeting Summary",
	"Exhibit(s)",
	"Fee Waiver Request",
	"Interrogatories",
	"Letter",
	"Miscellaneous",
	"Modify/Supplement Prior Filing Or The Record",
	"Motion For Protective Order",
	"Motion To Compel",
	"Motion To Dismiss Or Discontinue",
	"Motion To Strike",
	"Motion To Withdraw",
	"Motion/Petition/Request",
	"Motion/Request To Vacate Trail Use Agreement",
	"Notice",
	"Notice of Arbitration Decision",
	"Notice Of Exemption",
	"Notice Of Intent To Initiate Case",
	"Notice Of Intent To Participate (With Comment)",
	"Notice Of Intent To Participate (Without Comment)",
	"Notice Of Intent To Participate In Oral Argument/Hearing",
	"Notice Of Modified Certificate Of Public Convenience & Necessity - 49 CFR 1150.21",
	"Objection to Request for Waybill Data",
	"OFA - Agreement Reached/Terms Of Sale Accepted",
	"OFA - Notice Of Intent To File OFA",
	"OFA - Offer Of Financial Assistance",
	"OFA - Request To Set Terms",
	"OFA - Terms Of Sale Rejected",
	"OFA - Withdraw Offer Of Financial Assistance",
	"Opening Statement",
	"Oral Argument Exhibits",
	"Oral Argument/Hearing Request",
	"Petition",
	"Petition For Declaratory Order",
	"Petition For Exemption",
	"Petition For Reconsideration",
	"Petition For Rulemaking",
	"Petition For Stay",
	"Petition For Waiver",
	"Petition To Intervene",
	"Petition to Reject",
	"Petition To Reopen",
	"Petition To Revoke Exemption",
	"Petition To Substitute Applicant",
	"Petition To Substitute Trail User",
	"Petition To Suspend And Investigate",
	"Protest/Opposition Statement",
	"Public Use Condition Request",
	"Rebuttal",
	"Reply",
	"Reply Comments",
	"Reply To Appeal",
	"Request For Extension Of Time",
	"Request For Informal Opinion",
	"Request For Merger Condition(s)",
	"Request for Waybill Data",
	"Responsive Or Inconsistent Application",
	"Roster Of Arbitrators",
	"Safety Implementation Plan",
	"Schedule 13D (And Supplements) - 49 CFR 1013.3(c)",
	"Section 5 Summary",
	"Settlement/Agreement/Amendment",
	"Status Report",
	"Stipulation",
	"Substitution/Withdrawal Of Counsel",
	"Support Statement",
	"System Diagram Map",
	"Trail Use Agreement Reached",
	"Trail Use Extension",
	"Trail Use Request",
	"Transcript Of Discovery Conference",
	"Transcript Of Hearing/Conference",
	"Transcript Of Oral Argument",
	"Verified Statement",
	"Voting Trust Agreement",
	"Waybill Access",
	"Workpapers",
	"Written Testimony"
];

export const ISSUES = [
	"Amtrak or Passenger Rail Issue",
	"Canadian or Mexican Rail Regulatory Issue",
	"Household Goods Moving Issue",
	"Information-Economic Data",
	"Information-Non Economic Request",
	"Meeting Request",
	"Motor Carrier (Trucking) Issue",
	"Passenger Bus Issue",
	"Pipeline Issue",
	"Railroad Agricultural Contract Filing",
	"Railroad Blocked Crossings",
	"Railroad Car Supply",
	"Railroad Claims",
	"Railroad Commercial or Billing Issue",
	"Railroad Common Carrier Obligation",
	"Railroad Competition Issues",
	"Railroad Demurrage Charges",
	"Railroad Denial of Rail Service",
	"Railroad Embargo",
	"Railroad Environmental Issues",
	"Railroad Freight Car Repair or Dispo",
	"Railroad Fuel Surcharge",
	"Railroad Hazardous Waste/Radioactive Waste",
	"Railroad Inter-carrier disputes",
	"Railroad Interchange Issue",
	"Railroad Intermodal Service",
	"Railroad Labor Issues",
	"Railroad Lease of track or equipment",
	"Railroad Liability Issues",
	"Railroad Maintenance Issue",
	"Railroad Miscellaneous Charges",
	"Railroad Noise - Airhorn, Safety, etc",
	"Railroad Operating Authority Issue",
	"Railroad Paper Barriers",
	"Railroad Preemption",
	"Railroad Rate Levels/Increases",
	"Railroad Reciprocal Switching",
	"Railroad Service Issue",
	"Railroad Side Track Agreement",
	"Railroad Stored Freight Cars",
	"Railroad Tariff Issue",
	"Rails to Trails",
	"Real Estate Matter",
	"STB Authority Question",
	"STB Fees",
	"STB Jurisdictional Question",
	"STB or ICC Records Assistance",
	"STB Procedural Assistance",
	"STB Recordations or Security Interests on Rail Cars",
	"STB Webpage/Downloading Assistance",
	"Water Carrier Issue (Non-contiguous Domestic Trade)",
	"Wrong Agency Calls",
	"Other"
];

export const COMMODITY_GROUPS = [
	"Agricultural Products",
	"Aggregates",
	"Automobile",
	"Chemicals",
	"Coal",
	"Construction Debris",
	"Construction Materials",
	"Empty Freight Cars",
	"Forest Products",
	"Hazardous Waste/Radioactive Waste",
	"High/Wide Loads",
	"Household Goods",
	"Industrial Products",
	"Intermodal",
	"Metals and Minerals",
	"Municipal Waste",
	"Not Specified by Shipper",
	"Passenger",
	"Other",
	"Toxic By Inhalation",
	"N/A"
];

export const REGIONS = [
	{
		name: "Northeast",
		hint: "Connecticut, Maine, Massachusetts, New Hampshire, New Jersey, New York, Pennsylvania, Rhode Island, and Vermont",
		color: '#dc3545'
	},{
		name: "South",
		hint: "Alabama, Arkansas, Delaware, Florida, Georgia, Kentucky, Louisiana, Maryland, Mississippi, North Carolina, Oklahoma, South Carolina, Tennessee, Texas, Virginia, and West Virginia",
		color: '#9e7700'
	},{
		name: "Midwest",
		hint: "Illinois, Indiana, Iowa, Kansas, Michigan, Minnesota, Missouri, Nebraska, North Dakota, Ohio, South Dakota, and Wisconsin",
		color: '#23903c'
	},{
		name: "West",
		hint: "Montana, Idaho, Wyoming, Colorado, New Mexico, Arizona, Utah, Nevada, California, Oregon, Washington, Alaska, and Hawaii",
		color: '#0071bc'
	},{
		name: "US Territory",
		hint: "US Territory",
		color: '#000'
	},{
		name: "International",
		hint: "International",
		color: '#000'
	}
]

export const US_STATE_OPTIONS = [
	{ name: "Alabama", abbrv: "AL" },
	{ name: "Alaska", abbrv: "AK" },
	{ name: "American Samoa", abbrv: "AS" },
	{ name: "Arizona", abbrv: "AZ" },
	{ name: "Arkansas", abbrv: "AR" },
	{ name: "California", abbrv: "CA" },
	{ name: "Colorado", abbrv: "CO" },
	{ name: "Connecticut", abbrv: "CT" },
	{ name: "Delaware", abbrv: "DE" },
	{ name: "District of Columbia", abbrv: "DC"},
	{ name: "Federated States of Micronesia", abbrv: "FM" },
	{ name: "Florida", abbrv: "FL" },
	{ name: "Georgia", abbrv: "GA" },
	{ name: "Guam", abbrv: "GU"},
	{ name: "Hawaii", abbrv: "HI" },
	{ name: "Idaho", abbrv: "ID" },
	{ name: "Illinois", abbrv: "IL" },
	{ name: "Indiana", abbrv: "IN" },
	{ name: "Iowa", abbrv: "IA" },
	{ name: "Kansas", abbrv: "KS" },
	{ name: "Kentucky", abbrv: "KY" },
	{ name: "Louisiana", abbrv: "LA" },
	{ name: "Maine", abbrv: "ME" },
	{ name: "Marshall Islands", abbrv: "MH" },
	{ name: "Maryland", abbrv: "MD" },
	{ name: "Massachusetts", abbrv: "MA" },
	{ name: "Michigan", abbrv: "MI" },
	{ name: "Minnesota", abbrv: "MN" },
	{ name: "Mississippi", abbrv: "MS" },
	{ name: "Missouri", abbrv: "MO" },
	{ name: "Montana", abbrv: "MT" },
	{ name: "Nebraska", abbrv: "NE" },
	{ name: "Nevada", abbrv: "NV" },
	{ name: "New Hampshire", abbrv: "NH" },
	{ name: "New Jersey", abbrv: "NJ" },
	{ name: "New Mexico", abbrv: "NM" },
	{ name: "New York", abbrv: "NY" },
	{ name: "North Carolina", abbrv: "NC" },
	{ name: "North Dakota", abbrv: "ND" },
	{ name: "Northern Mariana Islands", abbrv: "MP" },
	{ name: "Ohio", abbrv: "OH" },
	{ name: "Oklahoma", abbrv: "OK" },
	{ name: "Oregon", abbrv: "OR" },
	{ name: "Palau", abbrv: "PW" },
	{ name: "Pennsylvania", abbrv: "PA" },
	{ name: "Puerto Rico", abbrv: "PR"},
	{ name: "Rhode Island", abbrv: "RI" },
	{ name: "South Carolina", abbrv: "SC" },
	{ name: "South Dakota", abbrv: "SD" },
	{ name: "Tennessee", abbrv: "TN" },
	{ name: "Texas", abbrv: "TX" },
	{ name: "Utah", abbrv: "UT" },
	{ name: "Vermont", abbrv: "VT" },
	{ name: "Virgin Islands", abbrv: "VI"},
	{ name: "Virginia", abbrv: "VA" },
	{ name: "Washington", abbrv: "WA" },
	{ name: "West Virginia", abbrv: "WV" },
	{ name: "Wisconsin", abbrv: "WI" },
	{ name: "Wyoming", abbrv: "WY" }
];

export const FEE_OPTIONS = [
	{
		label: "Fee required (no waiver requested)",
		value: "Fee required (no waiver requested)"
	},
	{
		label: "Fee required (waiver requested)",
		value: "Fee required (waiver requested)"
	},
	{ label: "No Fee Required", value: "No Fee Required" }
];

export const COUNTRIES = [
	"United States",
	"Afghanistan",
	"Albania",
	"Algeria",
	"Andorra",
	"Angola",
	"Antigua and Barbuda",
	"Argentina",
	"Armenia",
	"Australia",
	"Austria",
	"Azerbaijan",
	"Bahamas",
	"Bahrain",
	"Bangladesh",
	"Barbados",
	"Belarus",
	"Belgium",
	"Belize",
	"Benin",
	"Bhutan",
	"Bolivia",
	"Bosnia and Herzegovina",
	"Botswana",
	"Brazil",
	"Brunei",
	"Bulgaria",
	"Burkina Faso",
	"Burundi",
	"Cabo Verde",
	"Cambodia",
	"Cameroon",
	"Canada",
	"Central African Republic",
	"Chad",
	"Chile",
	"China",
	"Colombia",
	"Comoros",
	"Congo, Democratic Republic of the",
	"Congo, Republic of the",
	"Costa Rica",
	"Cote d'Ivoire",
	"Croatia",
	"Cuba",
	"Cyprus",
	"Czechia",
	"Denmark",
	"Djibouti",
	"Dominica",
	"Dominican Republic",
	"Ecuador",
	"Egypt",
	"El Salvador",
	"Equatorial Guinea",
	"Eritrea",
	"Estonia",
	"Eswatini",
	"Ethiopia",
	"Fiji",
	"Finland",
	"France",
	"Gabon",
	"Gambia",
	"Georgia",
	"Germany",
	"Ghana",
	"Greece",
	"Grenada",
	"Guatemala",
	"Guinea",
	"Guinea-Bissau",
	"Guyana",
	"Haiti",
	"Honduras",
	"Hungary",
	"Iceland",
	"India",
	"Indonesia",
	"Iran",
	"Iraq",
	"Ireland",
	"Israel",
	"Italy",
	"Jamaica",
	"Japan",
	"Jordan",
	"Kazakhstan",
	"Kenya",
	"Kiribati",
	"Kosovo",
	"Kuwait",
	"Kyrgyzstan",
	"Laos",
	"Latvia",
	"Lebanon",
	"Lesotho",
	"Liberia",
	"Libya",
	"Liechtenstein",
	"Lithuania",
	"Luxembourg",
	"Madagascar",
	"Malawi",
	"Malaysia",
	"Maldives",
	"Mali",
	"Malta",
	"Marshall Islands",
	"Mauritania",
	"Mauritius",
	"Mexico",
	"Micronesia",
	"Moldova",
	"Monaco",
	"Mongolia",
	"Montenegro",
	"Morocco",
	"Mozambique",
	"Myanmar",
	"Namibia",
	"Nauru",
	"Nepal",
	"Netherlands",
	"New Zealand",
	"Nicaragua",
	"Niger",
	"Nigeria",
	"North Korea",
	"North Macedonia",
	"Norway",
	"Oman",
	"Pakistan",
	"Palau",
	"Palestine",
	"Panama",
	"Papua New Guinea",
	"Paraguay",
	"Peru",
	"Philippines",
	"Poland",
	"Portugal",
	"Qatar",
	"Romania",
	"Russia",
	"Rwanda",
	"Saint Kitts and Nevis",
	"Saint Lucia",
	"Saint Vincent and the Grenadines",
	"Samoa",
	"San Marino",
	"Sao Tome and Principe",
	"Saudi Arabia",
	"Senegal",
	"Serbia",
	"Seychelles",
	"Sierra Leone",
	"Singapore",
	"Slovakia",
	"Slovenia",
	"Solomon Islands",
	"Somalia",
	"South Africa",
	"South Korea",
	"South Sudan",
	"Spain",
	"Sri Lanka",
	"Sudan",
	"Suriname",
	"Sweden",
	"Switzerland",
	"Syria",
	"Taiwan",
	"Tajikistan",
	"Tanzania",
	"Thailand",
	"Timor-Leste",
	"Togo",
	"Tonga",
	"Trinidad and Tobago",
	"Tunisia",
	"Turkey",
	"Turkmenistan",
	"Tuvalu",
	"Uganda",
	"Ukraine",
	"United Arab Emirates",
	"United Kingdom",
	"Uruguay",
	"Uzbekistan",
	"Vanuatu",
	"Vatican City",
	"Venezuela",
	"Vietnam",
	"Yemen",
	"Zambia",
	"Zimbabwe"
];

export const CONTACT_OPTIONS = [
	"Yes",
	"No",
	"N/A"
];

export const DECISION_TYPES = [
	"Corrected Decision", 
	"Corrected Environmental Review", 
	"Corrected Notice", 
	"Decision", 
	"Environmental Review", 
	"Notice", 
	"Notice Of Court Action", 
	"Notice of Exemption", 
	"Policy Statement"
];

export const DECIDING_BODIES = [
	"Accounting Board",
	"Administrative Law Judge",
	"Chairman",
	"Chief Counsel, Office of Chief Counsel",
	"Director Of Proceedings",
	"Director, Office Of Economics",
	"Director, Office Of Environmental Analysis",
	"Entire Board"
];

// News Constants
export const CATEGORIES = [
	"Abandonment",
	"Acquisition",
	"Agreements, rail",
	"Amtrak",
	"Amtrak-UP/SP",
	'Amtrak "Express" Traffic',
	"Amtrak/B&M Compensation",
	"Antitrust Immunity",
	"Arbitrators",
	"Banking (of rail corridors)",
	"Billing Disputes",
	"BN-Santa Fe Merger",
	"Bottleneck",
	"Burlington Northern-Canadian National",
	"Burlington Northern Santa Fe",
	"Buses",
	"Canadian National-Illinois Central",
	"Canadian National-Wisconsin Central",
	"Canadian Nat.--Great Lakes Transport.",
	"CN/EJ&E",
	"Compensation",
	"Competition",
	"Conrail",
	"Conrail/Pepco",
	"Continued Operation of Rail Lines",
	"Contracts",
	"Cost of capital",
	"Court decisions",
	"CSX-NS-Conrail",
	"Demurrage",
	"Directed service",
	"Dispute resolution",
	"DOT Study",
	"Environmental Assessment",
	"Ex Parte",
	"Exemption from regulation",
	"Federal Preemption",
	"Fees for Services",
	"Filings",
	"Grain Car Council",
	"Grain transportation",
	"Hazardous materials",
	"Household goods carriers",
	"Information exchange",
	"Interchange",
	'Interchange commitments ["paper barriers"]',
	"Investigations",
	"KCS-Tex Mex Merger",
	"Labor",
	"Labor Protection",
	"Lease transactions",
	"Line Acquisition",
	"Line sales",
	"Maps",
	"Mediation",
	"Memo of understanding",
	"Miscellaneous",
	"Monitoring",
	"Motor classification, rate bureaus",
	"Multiple dockets",
	"New Construction",
	"oral arguments",
	"Pipelines",
	"Pooling",
	"Positive Train Control",
	"Preemption",
	"Public Hearings",
	"Public Listening Session",
	"Public Meetings",
	"Publications",
	"Rail-Shipper Council",
	"Rail-Shipper Trnsprt Advis Com",
	"Rail access/competition",
	"Rail Car Oversight",
	"Rail Dispute Arbitration",
	"Rail Energy Trnsp Advis Com",
	"Rail Energy Trnsprt. Com.",
	"Rail lease cases",
	"Rail Mergers",
	"Rail Productivity",
	"Rail rates",
	"Rail Safety",
	"Rail Service",
	"RailAmerica-RailTex",
	"Railroad Rate Cases",
	"Rate Bureaus",
	"Rates",
	"RCAF Adjustment",
	"Reauthorization",
	"Regulations",
	"Regulations (bus)",
	"Regulatory Reform",
	"Reporting",
	"Revenue adequacy",
	"Revenue adequacy/competitive access",
	"Service",
	"Service orders",
	"STB jurisdiction",
	"STB operations",
	"STB Staff",
	"Studies",
	"Switching",
	"Tariff",
	"Tariff Filing",
	"Technology Implementation",
	"Trackage rights",
	"Transfer facilities",
	"Undercharges",
	"UP-SP Merger",
	"URCS",
	"User Fees",
	"Voting conferences",
	"Water carriers",
	"Waybill",
	"Waybill,RCAF"
];

// Transcripts Constants
export const TRANSCRIPT_DOCUMENT_TYPES = ["Statement", "Transcript", "Both"];

// Recordations Constants
export const RECORDATION_CATEGORIES = [{label:"Rail", value:"Rail"}, {label:"Water", value:"Water"}];

export const OTHER_PARTY_TYPE = "Other";

export const PARTY_TYPES = [
	"Assignee",
	"Assignor",
	"Bailee",
	"Bailor",
	"Borrower",
	"Creditor",
	"Debtor",
	"Grantee",
	"Grantor",
	"Lender",
	"Lessee",
	"Lessor",
	"Mortgagee",
	"Mortgagor",
	"Secured Party",
	"Trustee",
	"Vendee",
	"Vendor",
	OTHER_PARTY_TYPE
];

export const ENV_COMM_TYPES = [{label: "All", value: -1}, {label: "Incoming", value: 18}, {label: "Outgoing", value: 19}];

export const ATTENTION_LIST = [
	"OEA/Unknown",
	"Roslyn Anderson",
	"Adam Assenza",
	"Danielle Gosselin",
	"Andrea Poole",
	"Karen Stevens",
	"Alan Tabachnick",
	"Diana Wood"
];

export const AFFILIATION_LIST = [
	"Self/Individual",
	"Applicant",
	"Citizens Group",
	"Congressional",
	"Environmental Organization",
	"Federal Agency",
	"Local Interest",
	"Local Government",
	"State Agency",
	"State Government Official",
	"Tribal Official",
	"Tribal Member"
];